import React, { useContext, useState, useEffect } from "react";
import PromotionalProductSingleCategory from "../../components/promotional-product-categories/PromotionalProductSingleCategory";
import SectionTitle from "../../components/section-title/SectionTitle";
import { AuthContext } from "../../common/Auth"
import PropTypes from "prop-types";
import PromotionalProductCatEditIcon from "../../pages/promotion-product-cat/PromotionalProductCatEditIcon"

const PromotionalProductCategories = () => {

    const { promotionalProductCat, themeSettingsData } = useContext(AuthContext)

    const [data, setData] = useState({})
    const [dataId, setDataId] = useState("")
    
    useEffect(() => {
        if (themeSettingsData && themeSettingsData.length && themeSettingsData.length > 0) {
            themeSettingsData.map((i) => {
                if (i.settingsName === "promotionalProductCategory") {
                    setData(i.values[0]);
                    setDataId(i._id);
                }
            })
        }
    }, [themeSettingsData])

    let pt = data.paddingTop ? data.paddingTop : "pt-50";
    let pb = data.paddingBottom ? data.paddingBottom : "pb-50";
    let mb = data.marginBottom ? data.marginBottom : "mt-50";
    let mt = data.marginTop ? data.marginTop : "mb-50";
    let mr = data.marginRight ? data.marginRight : "mr-0";
    let ml = data.marginLeft ? data.marginLeft : "ml-0";
    let pl = data.paddingLeft ? data.paddingLeft : "pl-0";
    let pr = data.paddingRight ? data.paddingRight : "pr-0";
    let fullSection = data.fullSection ? "container-fluid" : "container";
    let bgImage = data?.bgImage ? data?.bgImage : "";
    let bgColor = data?.bgColor ? data?.bgColor : "";
    let categoriesPerRow = data?.categoriesPerRow ? data?.categoriesPerRow : 2;

    return (
        <div className={`antera-featured-promo-cat-section-container blog-area section-bgImage ${pt} ${pb} ${mb} ${mt} ${mr} ${ml} ${pl} ${pr}`} 
        style={(bgImage.length > 0 ) ? {backgroundImage:`url(${bgImage})`} : {background:bgColor}}
         >
            <div className={`${fullSection}`} style={{padding:"0 16px"}}>
                <SectionTitle
                    titleText={data.sectionTitle ? data.sectionTitle : "Featured Promotional Product Categories"}
                    titlepositionClass={data.sectionTitleAlign ? data.sectionTitleAlign : "text-center"}
                    spaceClass="mb-30"
                    borderClass={data.sectionTitleBorder ? data.sectionTitleBorder : "no-border"}
                    
                />
                <div className="edit-inline">
                    <PromotionalProductCatEditIcon proCatId={dataId} fromEditAction="topBottomSpace" />
                </div>
                <div className="row">
                    {promotionalProductCat && promotionalProductCat.length &&
                        promotionalProductCat.map((single, key) => {
                            single.diagGrayBackground = data.diagGrayBackground;
                            return (
                                <PromotionalProductSingleCategory data={single} key={key} categoriesPerRow={categoriesPerRow} />
                            )
                        })}
                </div>
            </div>
        </div>
    );
};

PromotionalProductSingleCategory.propTypes = {}

export default PromotionalProductCategories;
